import { Component, OnInit } from '@angular/core';
import { SourceService } from '../../data-access-layer/services/sources.service';
import { DatabaseSchemaModel, FilesResponse, FunctionModel, ProcedureModel, SourceBI, SourceDWH, TableModel, ViewModel } from '../../data-access-layer/interfaces/source.interface';
import { AuthService } from '../../data-access-layer/services/auth.service';
import '../templates/styles/content.component.css';
import {
  AllCommunityModule,
  CellStyleModule,
  ClientSideRowModelModule,
  ModuleRegistry,
  NumberEditorModule,
  TextEditorModule,
  ValidationModule,
} from "ag-grid-community";
import { BehaviorSubject, filter, forkJoin, lastValueFrom, takeUntil } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ChartResponse, FilterResponse, FolderResponse, MetricResponse, ReportResponse, SummarizedMetricResponse, TabResponse } from '../../data-access-layer/interfaces/source_db.interface';
import { AlertService } from '../../data-access-layer/services/alert.service';
import { PythonService } from '../../data-access-layer/services/python.service';
import { LoadingService } from '../../data-access-layer/services/loading.service';
import { LoadingComponent } from './loading.component';
import { ChatComponent } from './chat.component';
import { UserSessionStorageService } from '../../data-access-layer/services/user-sessions.service';
import { LoadingUpdatingService } from '../../data-access-layer/services/loading_updating.service';
import { TranslocoService } from '@ngneat/transloco';
import { TranslocoModule, TRANSLOCO_CONFIG, translocoConfig, TRANSLOCO_LOADER } from '@ngneat/transloco';
import TrieSearch from 'trie-search';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { saveAs } from 'file-saver-es';

ModuleRegistry.registerModules([AllCommunityModule,
  NumberEditorModule,
  TextEditorModule,
  CellStyleModule,
  ClientSideRowModelModule,
  ValidationModule]);


@Component({
  selector: 'app-root',
  templateUrl: '../templates/content_db.component.html',
  styleUrl: '../templates/styles/content.component.css',
  standalone: false,
})

export class ContentComponent implements OnInit {

  // cache TTL: 5 minutes
  private readonly CACHE_TTL_MS = 5 * 60 * 1000;

  isShowBI: boolean = false;

  sourcesDWH: SourceDWH[] = [];
  sourcesBI: SourceBI[] = [];

  currentDataSource: any;

  sources: any;
  open = false;

  isEdit: boolean = false;
  imagesUrl: string = environment.baseUrl;

  isSearching: boolean = false;
  searchText: string = '';

  isLoading: boolean = false;

  isChatVisible: boolean = false;

  chat: ChatComponent | any;

  //DWH

  schemas: DatabaseSchemaModel[] = [];
  tables: TableModel[] = [];
  historyElements: any[] = [];
  procedures: ProcedureModel[] = [];
  views: ViewModel[] = [];
  functions: FunctionModel[] = [];

  private allTables: TableModel[] = [];
  private allViews: ViewModel[] = [];
  private allProcedures: ProcedureModel[] = [];
  private allFunctions: FunctionModel[] = [];
  private allSchemas: DatabaseSchemaModel[] = [];
  private allReports: ReportResponse[] = [];

  elementType: string = '';
  currentSchema: DatabaseSchemaModel | any;

  currentElement: any = undefined;
  schemasOpen = false;

  isOpen = false;

  selectedStepIndex: number | null = null;
  selectedSourceIndex: number | null = null;

  //BI

  filteredFolders: FolderResponse[] = [];
  currentReport: ReportResponse | any;
  currentTab: TabResponse | any;
  reportTabs: TabResponse[] = [];

  reports: ReportResponse[] | undefined;
  tabs: TabResponse[] | undefined;
  filters: FilterResponse[] | undefined;
  charts: ChartResponse[] | undefined;

  metrics: MetricResponse[] | undefined;
  summarizedMetrics: SummarizedMetricResponse[] | undefined;
  filteredSummarizedMetrics: SummarizedMetricResponse[] | undefined;
  metricReports: ReportResponse[] | undefined;
  isLoadingAsync: boolean = false;
  public folderTree: any[] | undefined;
  public files: any[] = [];

  historyReports: any[] | undefined;

  // caches store value + timestamp for TTL handling
  private reportTabsCache = new Map<number, { ts: number, data: TabResponse[] }>();
  private tabChartsCache = new Map<number, { ts: number, data: ChartResponse[] }>();
  private tabFiltersCache = new Map<number, { ts: number, data: FilterResponse[] }>();
  private summarizedMetricCache = new Map<number, { ts: number, data: MetricResponse[] }>();
  private reportsCache = new Map<number, { ts: number, data: ReportResponse[] }>();
  isVisibleImage = false;
  selectedImage: string = "";

  constructor(private sourceService: SourceService, private route: ActivatedRoute, public authService: AuthService, private pythonService: PythonService, private loadingService: LoadingService, private sessionService: UserSessionStorageService, public transloco: TranslocoService, private router: Router, private alertService: AlertService) {
    this.loadingService.loading$.subscribe((loading: boolean) => {
      this.isLoading = loading;
    });
  }


  ngOnInit(): void {
    const restoreElement = this.sessionService.getItem('currentElement');
    const restoreDataSource = this.sessionService.getItem('currentDataSource');
    const restoreElementType = this.sessionService.getItem('elementType');
    const restoreIsBI = this.sessionService.getItem('isBI');

    // Определяем режим BI/DWH из sessionStorage
    this.isShowBI = restoreIsBI === true || restoreIsBI === 'true';

    if (this.isShowBI) {
      this.sourceService.getBISources().subscribe((response) => {
          this.sources = response;
      });
    } else {
      this.sourceService.getDWHSources().subscribe((response) => {
          this.sources = response;
          this.sessionService.setItem("isBI", false);
      });
    }

    if (restoreElement && restoreElementType) {
      setTimeout(() => {
        this.restoreElement(restoreElement, restoreElementType, restoreDataSource);
        this.open = true;
      }, 500);
    }
  }

  public loadFile() {
    const reportId = this.currentElement.id;

    this.checkReportFilesStatus(reportId, () => {
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.accept = '.pbit';
      fileInput.style.display = 'none';

      fileInput.onchange = (event: Event) => {
        const input = event.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
          const file = input.files[0];
          this.uploadFileForReport(reportId, file);
        }
        document.body.removeChild(fileInput);
      };

      document.body.appendChild(fileInput);
      fileInput.click();
    });
  }

  private checkReportFilesStatus(reportId: number, callback: () => void): void {
    this.pythonService.getReportFilesStatus(reportId).subscribe(() => {
      if (this.files.length > 0) {
        this.pythonService.deleteReportFiles(reportId, this.files[0].file_name).subscribe(() => { callback(); });
     } else {
      // Нет файлов - сразу открываем диалог выбора
      callback();
    }
    });
  }

  private uploadFileForReport(reportId: number, file: File): void {
    if (!file) {
      this.alertService.error('Ошибка', 'Файл не выбран');
      return;
    }

    this.loadingService.setLoading(true);
    this.pythonService.uploadFile(reportId, file).subscribe({
      next: (response) => {
        this.loadingService.setLoading(false);
        console.log('Файл успешно загружен:', response);
        this.alertService.success('Успешно', 'Файл успешно загружен');
        this.refreshReportFilesStatus(reportId);
      },
      error: (error: any) => {
        this.loadingService.setLoading(false);
        console.error('Ошибка при загрузке файла:', error);
        this.alertService.error('Ошибка загрузки', error.error?.message || error.message || 'Неизвестная ошибка при загрузке файла');
      }
    });
  }

  public async refreshReportFilesStatus(reportId: number): Promise<void> {
    try {
      const files: FilesResponse = await lastValueFrom(
        this.pythonService.getReportFilesStatus(reportId)
      );

      this.files = Array.isArray(files) ? files : (files && files.files) || [];
    } catch (error: any) {
      console.error('Ошибка при обновлении статуса файлов:', error);
      this.files = [];
    }
  }

  public downloadReportFile(reportId: number, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (!this.files || this.files.length === 0) {
      console.warn('Нет доступных файлов для скачивания');
      this.alertService.warning('Файлы не найдены', 'Нет доступных файлов для скачивания');
      return;
    }

    const fileName = this.files[0].file_name;
    console.log('Начало скачивания файла:', fileName, 'для отчета:', reportId);

    this.pythonService.getReportFiles(reportId, fileName).subscribe({
      next: (blob: Blob) => {
        const downloadFileName = fileName.endsWith('.pbit') ? fileName : `${fileName}.pbit`;

        try {
          saveAs(blob, downloadFileName);
          console.log('Файл успешно скачан:', downloadFileName);
          this.alertService.success('Успешно', 'Файл успешно загружен');
        } catch (saveError: any) {
          console.error('Ошибка при сохранении файла:', saveError);
          this.alertService.error('Ошибка сохранения', 'Не удалось сохранить файл');
        }
      },
      error: (error: any) => {
        console.error('Ошибка при загрузке файла:', error);
        this.alertService.error('Ошибка загрузки', error.error?.message || error.message || 'Неизвестная ошибка при загрузке файла');
      }
    });
  }

  private async restoreElement(element: any, elementType: string, dataSource: any) {
    this.loadingService.setLoading(true);
    try {
      await this._restoreElementInner(element, elementType, dataSource);
    } finally {
      this.loadingService.setLoading(false);
    }
  }

  private async _restoreElementInner(element: any, elementType: string, dataSource: any) {
    // Шаг 1: Если нет element.id - выходим
    if (!element?.id) {
      if (dataSource) {
        await this.select(dataSource, true);
      }
      return;
    }

    const elementTypeLower = elementType.toLowerCase();
    const biTypes = ['report', 'chart'];
    const isBI = biTypes.includes(elementTypeLower);

    try {
      // Шаг 2: Получаем информацию об элементе по ID
      const elementResponse = await lastValueFrom(
        this.sourceService.getElementByIdOnly(element.id, elementTypeLower)
      );

      if (!elementResponse) {
        console.warn('restoreElement: element not found by id', element.id);
        if (dataSource) {
          await this.select(dataSource, true);
        }
        return;
      }

      // Обновляем данные элемента из ответа
      element.schemaId = elementResponse.schemaId;
      element.name = elementResponse.name || element.name;

      // Шаг 3: Получаем dataSourceId по schemaId/folderId
      let dataSourceId: number = -1;

      if (isBI) {
        // Для BI: schemaId в ответе содержит folderId
        const folderId = elementResponse.schemaId;
        dataSourceId = await lastValueFrom(
          this.sourceService.getDataSourceIdByFolderIdBI(folderId)
        );
      } else {
        // Для DWH: schemaId в ответе - это schemaId
        const schemaId = elementResponse.schemaId;
        dataSourceId = await lastValueFrom(
          this.sourceService.getDataSourceIdBySchemaIdDWH(schemaId)
        );
      }

      if (dataSourceId <= 0) {
        console.warn('restoreElement: could not find dataSourceId');
        if (dataSource) {
          await this.select(dataSource, true);
        }
        return;
      }

      // Шаг 4: Ожидаем загрузки sources, если еще не загружены
      const waitForSources = async (maxAttempts = 30, delay = 100) => {
        let attempts = 0;
        while ((!this.sources || this.sources.length === 0) && attempts < maxAttempts) {
          await new Promise(resolve => setTimeout(resolve, delay));
          attempts++;
        }
      };
      await waitForSources();

      // Шаг 5: Находим dataSource по ID
      const foundDataSource = (this.sources || []).find((ds: any) => ds.id === dataSourceId);

      if (!foundDataSource) {
        console.warn('restoreElement: dataSource not found in sources list', dataSourceId);
        if (dataSource) {
          await this.select(dataSource, true);
        }
        return;
      }

      // Шаг 6: Выбираем dataSource
      await this.select(foundDataSource, true);

      if (isBI) {
        const waitForFolders = async (maxAttempts = 30, delay = 100) => {
          let attempts = 0;
          while ((!this.filteredFolders || this.filteredFolders.length === 0) && attempts < maxAttempts) {
            await new Promise(resolve => setTimeout(resolve, delay));
            attempts++;
          }
        };
        await waitForFolders();

        const folderId = elementResponse.schemaId;
        const folder = (this.filteredFolders || []).find((f: any) => f.id === folderId);

        const loadFolderReportsAndSync = async (fId: number) => {
          const reports = await this.getReportsCached(fId);
          const f = this.filteredFolders?.find((x: any) => x.id === fId);
          if (f) {
            f.reports = reports;
            f.filteredReports = reports || [];
          }
          this.folderTree = this.buildFolderTree(this.filteredFolders || []);
        };

        if (folder) {
          await loadFolderReportsAndSync(folderId);
          if (elementTypeLower === 'report') {
            await this.displayReport(element.id);
          } else {
            this.selectElement(element, elementType);
          }
          return;
        }

        if (this.filteredFolders && this.filteredFolders.length > 0) {
          await loadFolderReportsAndSync(this.filteredFolders[0].id);
        }
        if (elementTypeLower === 'report') {
          await this.displayReport(element.id);
        } else {
          this.selectElement(element, elementType);
        }
        return;
      }

      // DWH: ожидаем загрузки схем
      const waitForSchemas = async (maxAttempts = 30, delay = 100) => {
        let attempts = 0;
        while ((!this.allSchemas || this.allSchemas.length === 0) && attempts < maxAttempts) {
          await new Promise(resolve => setTimeout(resolve, delay));
          attempts++;
        }
      };
      await waitForSchemas();

      // Шаг 8: Находим схему по schemaId
      const schema = (this.allSchemas || []).find((s: any) => s.id === elementResponse.schemaId);

      if (schema) {
        this.currentSchema = schema;
        element.schema = schema.name;

        if (this.loadDWHData) {
          await this.loadDWHData(schema.id);
        }
        this.selectElement(element, elementType);
        return;
      }

      // Если схема не найдена - берем первую
      if (this.allSchemas && this.allSchemas.length > 0) {
        this.currentSchema = this.allSchemas[0];
        await this.loadDWHData(this.currentSchema.id);
      }

      this.selectElement(element, elementType);

    } catch (err) {
      console.warn('restoreElement: error during restore', err);
      // Fallback на старую логику с dataSource из sessionStorage
      if (dataSource) {
        await this.select(dataSource, true);
        this.selectElement(element, elementType);
      }
    }
  }

  private isExpired<T>(entry?: { ts: number, data: T[] } | null | undefined) {
    if (!entry) return true;
    return (Date.now() - entry.ts) > this.CACHE_TTL_MS;
  }

  private async getReportsCached(folderId: number): Promise<ReportResponse[]> {
    const entry = this.reportsCache.get(folderId);
    if (!this.isExpired(entry)) return entry!.data;

    try {
      const resp = await lastValueFrom(this.sourceService.getReports(folderId));
      const arr: ReportResponse[] = Array.isArray(resp) ? resp : [];
      this.reportsCache.set(folderId, { ts: Date.now(), data: arr });

      // merge into allReports
      for (const r of arr) {
        if (!this.allReports.some(ar => ar.id === r.id)) this.allReports.push(r);
      }

      return arr;
    } catch (err) {
      this.reportsCache.set(folderId, { ts: Date.now(), data: [] });
      console.warn('getReportsCached failed for', folderId, err);
      return [];
    }
  }

  private async getTabsCached(reportId: number): Promise<TabResponse[]> {
    const entry = this.reportTabsCache.get(reportId);
    if (!this.isExpired(entry)) return entry!.data;

    try {
      const resp = await lastValueFrom(this.sourceService.getTabs(reportId));
      const arr = Array.isArray(resp) ? resp : [];
      this.reportTabsCache.set(reportId, { ts: Date.now(), data: arr });
      return arr;
    } catch (err) {
      this.reportTabsCache.set(reportId, { ts: Date.now(), data: [] });
      return [];
    }
  }

  private async getChartsCached(tabId: number): Promise<ChartResponse[]> {
    const entry = this.tabChartsCache.get(tabId);
    if (!this.isExpired(entry)) return entry!.data;

    try {
      const resp = await lastValueFrom(this.sourceService.getCharts(tabId));
      const arr = Array.isArray(resp) ? resp : [];
      this.tabChartsCache.set(tabId, { ts: Date.now(), data: arr });
      return arr;
    } catch {
      this.tabChartsCache.set(tabId, { ts: Date.now(), data: [] });
      return [];
    }
  }

  private async getFiltersCached(tabId: number): Promise<FilterResponse[]> {
    const entry = this.tabFiltersCache.get(tabId);
    if (!this.isExpired(entry)) return entry!.data;

    try {
      const resp = await lastValueFrom(this.sourceService.getFilters(tabId));
      const arr = Array.isArray(resp) ? resp : [];
      this.tabFiltersCache.set(tabId, { ts: Date.now(), data: arr });
      return arr;
    } catch {
      this.tabFiltersCache.set(tabId, { ts: Date.now(), data: [] });
      return [];
    }
  }

  private async getMetricsCached(summarizedMetricId: number): Promise<MetricResponse[]> {
    const entry = this.summarizedMetricCache.get(summarizedMetricId);
    if (!this.isExpired(entry)) return entry!.data;

    try {
      const req = { dataSourceId: this.currentDataSource.id, summarizedMetricId };
      const resp = await lastValueFrom(this.sourceService.getMetrics(req));
      const arr = Array.isArray(resp) ? resp : [];
      this.summarizedMetricCache.set(summarizedMetricId, { ts: Date.now(), data: arr });
      return arr;
    } catch (err) {
      this.summarizedMetricCache.set(summarizedMetricId, { ts: Date.now(), data: [] });
      console.warn('getMetricsCached failed for', summarizedMetricId, err);
      return [];
    }
  }

  selectElement(el: any, elementType: string) {
    this.currentElement = el;
    this.isOpen = false;
    this.displayElement(el.id, elementType);
  }

  buildFolderTree(folders: any[]): any[] {
    const map = new Map<number, any>();
    const roots: any[] = [];

    // сохраняем все поля папки + children
    folders.forEach(f => map.set(f.id, { ...f, children: [] }));

    map.forEach(f => {
      // проверяем на null/undefined, а не на truthy
      if (f.parentId != null && map.has(f.parentId)) {
        map.get(f.parentId).children.push(f);
      } else {
        roots.push(f);
      }
    });

    return roots;
  }


  getReports(folderId: number) {
    const folder = this.filteredFolders.find(x => x.id === folderId);
    if (!folder) return;

    this.sourceService.getReports(folderId).subscribe((response) => {
      folder.reports = response || [];
      folder.filteredReports = response || [];

      // обновляем глобальный список отчетов
      const map = new Map<number, any>();
      for (const r of this.allReports || []) map.set(r.id, r);
      for (const r of folder.reports) map.set(r.id, r);
      this.allReports = Array.from(map.values());

      // cache it as well
      this.reportsCache.set(folderId, { ts: Date.now(), data: Array.isArray(response) ? response : [] });

      // перестраиваем дерево после того как в папке появились reports
      this.folderTree = this.buildFolderTree(this.filteredFolders || []);

      this.findElement();
    });
  }

  async loadDWHData(dataSourceId: number) {
    await this.getTables(dataSourceId)
    await this.getFunctions(dataSourceId)
    await this.getProcedures(dataSourceId)
    await this.getViews(dataSourceId)

    this.findElement()
  }

  displayElement(elementId: number, elementType: string) {
    this.elementType = elementType;
    this.isEdit = false;
    this.isOpen = false;


    const schemaId = this.currentSchema.id;
    if (!schemaId) {
      console.error('displayElement: не удалось определить schemaId для элемента', elementId, elementType);
      return;
    }

    const assignAndLoadHistory = (element: any, historyLoader: () => void) => {
      if (!element) {
        console.warn('displayElement: пустой response для', elementId, elementType);
        return;
      }
      this.currentElement = element;
      historyLoader();
    };

    switch (elementType) {
      case 'Table':
        this.sourceService.getTableById(schemaId, elementId).subscribe((response: any) => {
          const result = Array.isArray(response) ? (response.find((x: any) => x.id === elementId) ?? response[0]) : response;
          assignAndLoadHistory(result, () => {
            if (this.currentElement && this.currentElement.schemaId && this.currentElement.code)
              this.sourceService.getHistoryTables(this.currentElement.schemaId, this.currentElement.code)
                .subscribe((r) => this.historyElements = r);
          });
        });
        break;

      case 'Procedure':
        this.sourceService.getProcedureById(schemaId, elementId).subscribe((response: any) => {
          const result = Array.isArray(response) ? (response.find((x: any) => x.id === elementId) ?? response[0]) : response;
          assignAndLoadHistory(result, () => {
            if (this.currentElement && this.currentElement.schemaId && this.currentElement.code)
              this.sourceService.getHistoryProcedures(this.currentElement.schemaId, this.currentElement.code)
                .subscribe((r) => this.historyElements = r);
          });
        });
        break;

      case 'View':
        this.sourceService.getViewById(schemaId, elementId).subscribe((response: any) => {
          const result = Array.isArray(response) ? (response.find((x: any) => x.id === elementId) ?? response[0]) : response;
          assignAndLoadHistory(result, () => {
            if (this.currentElement && this.currentElement.schemaId && this.currentElement.code)
              this.sourceService.getHistoryViews(this.currentElement.schemaId, this.currentElement.code)
                .subscribe((r) => this.historyElements = r);
          });
        });
        break;

      case 'Function':
        this.sourceService.getFunctionById(schemaId, elementId).subscribe((response: any) => {
          const result = Array.isArray(response) ? (response.find((x: any) => x.id === elementId) ?? response[0]) : response;
          assignAndLoadHistory(result, () => {
            if (this.currentElement && this.currentElement.schemaId && this.currentElement.code)
              this.sourceService.getHistoryFunctions(this.currentElement.schemaId, this.currentElement.code)
                .subscribe((r) => this.historyElements = r);
          });
        });
        break;



      default:
        console.warn('displayElement: неизвестный тип элемента', elementType);
        break;
    }
  }

  async getTables(dataSourceId: number) {
    const response = await lastValueFrom(this.sourceService.getTables(dataSourceId));
    this.allTables = response;
  }

  async getProcedures(dataSourceId: number): Promise<void> {
    const response = await lastValueFrom(this.sourceService.getProcedures(dataSourceId));
    this.allProcedures = response;
  }

  async getViews(dataSourceId: number): Promise<void> {
    const response = await lastValueFrom(this.sourceService.getViews(dataSourceId));
    this.allViews = response;
  }

  async getFunctions(dataSourceId: number): Promise<void> {
    const response = await lastValueFrom(this.sourceService.getFunctions(dataSourceId));
    this.allFunctions = response;
  }

  toggleIsBI(isBI: boolean) {
    this.isShowBI = isBI;
    this.clearAll();
    this.currentDataSource = undefined;
  this.sessionService.setItem("currentDataSource", this.currentDataSource);
  this.sessionService.setItem("isBI", isBI);

  if (this.isShowBI) {
      this.isChatVisible = false;
      this.sourceService.getBISources().subscribe((response) => {
        this.sources = response;
      });
    }
    else {
      this.sourceService.getDWHSources().subscribe((response) => {
        this.sources = response;
      });
    }
  }

  clearAll() {
    this.schemas = [];
    this.tables = [];
    this.views = [];
    this.functions = [];
    this.procedures = [];

    this.allSchemas = [];
    this.allTables = [];
    this.allViews = [];
    this.allFunctions = [];
    this.allProcedures = [];
    this.currentElement = undefined;
    this.currentTab = undefined;
    this.isEdit = false;
    this.filteredFolders = [];
    this.reports = [];
    // clear caches when switching context
    this.reportTabsCache.clear();
    this.tabChartsCache.clear();
    this.tabFiltersCache.clear();
    this.summarizedMetricCache.clear();
    this.reportsCache.clear();
  }

  async onContentChange(skipAutoSelect: boolean = false) {
    this.clearAll();
    if (this.isShowBI) {
      const folders = await lastValueFrom(this.sourceService.getFolders(this.currentDataSource.id));
      this.filteredFolders = folders;
        this.elementType = 'Folder';
        this.filteredFolders.forEach(f => this.getReports(f.id))
        this.findElement();

      const metrics = await lastValueFrom(this.sourceService.getSummarizedMetrics(this.currentDataSource.id));
      this.summarizedMetrics = metrics;
      this.filteredSummarizedMetrics = Array.isArray(metrics) ? metrics.slice() : [];
    }
    else {
      const schemas = await lastValueFrom(this.sourceService.getSchemas(this.currentDataSource.id));
      this.allSchemas = schemas;
      this.schemas = schemas;
      
      if (this.schemas.length === 0)
        return;

      // Если skipAutoSelect = true, не устанавливаем схему и не загружаем данные автоматически
      // (используется при восстановлении элемента, чтобы сначала найти правильную схему)
      if (!skipAutoSelect) {
        this.currentSchema = this.schemas[0];
        this.loadDWHData(this.currentSchema.id);
      }
    }
  }

  async showMetrics(summarizedMetricId: number) {
    if (!this.currentDataSource) return;

    const request = {
      dataSourceId: this.currentDataSource.id,
      summarizedMetricId: summarizedMetricId
    };

    this.isLoadingAsync = true;
    try {
      const [metricsResp, metricReportsResp] = await Promise.all([

        this.getMetricsCached(summarizedMetricId),
        lastValueFrom(this.sourceService.getMetricReports(request)).catch(() => [])
      ]);

      const group = this.summarizedMetrics?.find(x => x.id === summarizedMetricId);
      if (group) {
        group.metrics = Array.isArray(metricsResp) ? metricsResp : [];
        this.currentElement = group;
        this.elementType = 'ReportMetric';
      }

      this.metricReports = Array.isArray(metricReportsResp) ? metricReportsResp : [];

      // pre-load reports into cache for faster metric-related operations (but do not mutate left-side folder.reports)
      const folders = Array.isArray(this.filteredFolders) ? this.filteredFolders : [];
      await Promise.all(folders.map(f => this.getReportsCached(f.id)));

    } catch (err) {
      console.error('showMetrics error', err);
    } finally {
      this.isLoadingAsync = false;
    }
  }

  showMetricInfo(metricId: number) {

    let request = {
      dataSourceId: this.currentDataSource.id,
      metricId: metricId
    }

    this.sourceService.getReportsByMetric(request).subscribe((response: any[]) => {
      const currentMetric = this.currentElement.metrics.find((x: any) => x.id === metricId);
      if (!currentMetric) return;

      // raw
      currentMetric.used = response || [];

      // processing
      const reportsMap = new Map<number, any>();
      const tabsSet = new Set<string>(); // key = `${reportId}::${tabName}`
      const chartsSet = new Set<string>();
      const grouped = new Map<number, { report: any; tabs: Map<string, Set<string>> }>();

      for (const item of response || []) {
        const report = item?.report;
        if (!report || report.id == null) continue;

        if (!reportsMap.has(report.id)) reportsMap.set(report.id, report);
        if (!grouped.has(report.id)) grouped.set(report.id, { report, tabs: new Map() });
        const group = grouped.get(report.id)!;

        const tabName = (item?.tabName ?? '').toString().trim();
        if (tabName) {
          tabsSet.add(`${report.id}::${tabName}`);
          if (!group.tabs.has(tabName)) group.tabs.set(tabName, new Set());
        }

        // normalize charts: accept item.chart, item.chartNames (string or array)
        let charts: string[] = [];
        if (Array.isArray(item?.chartNames)) {
          charts = item.chartNames.map((c: any) => (c ?? '').toString().trim()).filter(Boolean);
        } else if (typeof item?.chartNames === 'string' && item.chartNames.trim()) {
          charts = item.chartNames.split(',').map((s: string) => s.trim()).filter(Boolean);
        } else if (typeof item?.chart === 'string' && item.chart.trim()) {
          charts = [item.chart.trim()];
        }

        for (const ch of charts) {
          chartsSet.add(ch);
          if (tabName) group.tabs.get(tabName)!.add(ch);
        }
      }

      // outputs
      const uniqueReports = Array.from(reportsMap.values());
      const uniqueTabs = Array.from(tabsSet).map(k => {
        const [reportIdStr, tabName] = k.split('::');
        return { reportId: Number(reportIdStr), tabName };
      });
      const uniqueCharts = Array.from(chartsSet);

      const groupedOutput = Array.from(grouped.values()).map(g => ({
        report: g.report,
        tabs: Array.from(g.tabs.entries()).map(([tabName, chartSet]) => ({
          tabName,
          charts: Array.from(chartSet)
        }))
      }));

      // assign processed structure
      currentMetric.usedProcessed = {
        uniqueReports,
        uniqueTabs,
        uniqueCharts,
        grouped: groupedOutput
      };
    });

  }

  async displayReport(reportId: number) {
    this.currentElement = await this.allReports!.find(rep => rep.id === reportId);

    if (!this.currentElement) {
      console.error('Report not found:', reportId);
      return;
    }

    this.elementType = 'Report';

    if (this.currentElement.folderId != null && this.currentElement.code) {
      console.log('Loading report history for folderId:', this.currentElement.folderId, 'code:', this.currentElement.code);
      this.sourceService.getHistoryReports(this.currentElement.folderId, this.currentElement.code)
        .subscribe({
          next: (response) => {
            this.historyReports = response || [];
          }
        });
    } else {
      this.historyReports = [];
    }

    this.sourceService.getTabs(this.currentElement.id).subscribe((response) => {
      this.tabs = response;
      this.displayTab(this.tabs[0].id)
    });

    // Обновляем статус файлов только если это Power BI источник
    if (this.currentDataSource && this.currentDataSource.dbType && 
        this.currentDataSource.dbType.toLowerCase() === 'power bi') {
      await this.refreshReportFilesStatus(reportId);
      console.log('Files:', this.files, 'CurrentDataSource:', this.currentDataSource, 
                  'dbType:', this.currentDataSource.dbType, 
        'IsPowerBI:', this.currentDataSource.dbType.toLowerCase() === 'power bi',
        'FilesLength:', this.files.length);
      console.log('Type of files:', Object.prototype.toString.call(this.files));
    } else {
      // Если не Power BI, очищаем файлы
      this.files = [];
    }

    this.currentTab = undefined;
    this.filters = [];
    this.charts = [];
}

  displayTab(tabId: number) {
    this.currentTab = this.tabs!.find(tab => tab.id === tabId);

    this.sourceService.getFilters(tabId).subscribe((response) => {
      this.filters = response;
    });

    this.sourceService.getCharts(tabId).subscribe((response) => {
      this.charts = response;
    });
  }


  toggleEditing() {
    if (!this.isEdit) {
      this.isEdit = true;
      return;
    }

    this.saveElement();
    this.isEdit = false;
  }

  applyElement() {
    this.alertService.confirm({
      title: 'Внимание',
      message: this.currentElement.status ? `Отменить принятие "${this.currentElement.name}"?` : `Принять "${this.currentElement.name}"?`,
      confirmButtonText: 'Да',
      cancelButtonText: 'Отмена',
    }).subscribe(confirmed => {
      if (!confirmed) return;
      this.currentElement.status = !this.currentElement.status;
      this.saveElement();
    });
  }

  toggleOpen() {
    this.open = !this.open;
  }

  async select(source: any, skipAutoSelect: boolean = false) {
    this.currentDataSource = source;
    this.sessionService.setItem("currentDataSource", source);
    this.schemasOpen = true;
    await this.onContentChange(skipAutoSelect);
  }

  isSelected(source: any) {
    if (!this.currentDataSource) return false;
    return source.id === this.currentDataSource.id;
  }

  toggleSchemas() { this.schemasOpen = !this.schemasOpen; }

  isSchemaSelected(schema: any): boolean {
    return !!this.currentSchema && schema.id === this.currentSchema.id;
  }
  isTabSelected(tab: any): boolean {
    return !!this.currentTab && tab.id === this.currentTab.id;
  }


  isSelectedElement(element: any, elementType: string): boolean {
    return !!this.currentElement && element.id === this.currentElement.id && elementType === this.elementType;
  }

  selectSchema(schema: any) {
    this.currentSchema = schema;

    this.loadDWHData(schema.id);
  }

  saveElement() {
    switch (this.elementType) {
      case 'Table':
        this.sourceService.updateTable(this.currentElement).subscribe();
        break;
      case 'Procedure':
        this.sourceService.updateProcedure(this.currentElement).subscribe();
        break;
      case 'View':

        this.sourceService.updateView(this.currentElement).subscribe();

        break;
      case 'Function':
        this.sourceService.updateFunction(this.currentElement).subscribe();
        break;


      case 'Report': {
        const reportPayload = {
          id: this.currentElement.id ?? 0,
          code: this.currentElement.code ?? 0,
          name: this.currentElement.name ?? '',
          description: this.currentElement.description ?? '',
          sources: typeof this.currentElement.sources === 'string'
            ? (this.currentElement.sources as string)
              .split(',')
              .map((s: string) => s.trim())
              .filter((s: string) => !!s)
            : (this.currentElement.sources ?? []),
          status: this.currentElement.status ?? null,
          reference: this.currentElement.reference ?? '',
          folderId: this.currentElement.folderId ?? null
        };

        const tabs = (this.tabs ?? []).map(t => ({
          id: t.id ?? 0,
          reportId: t.reportId ?? 0,
          name: t.name ?? '',
          description: t.description ?? '',
          image: t.image ?? ''
        }));

        const requests = (this.tabs ?? []).map(t => {
          const tabPayload = {
            id: t.id ?? 0,
            reportId: t.reportId ?? 0,
            name: t.name ?? '',
            description: t.description ?? '',
            image: t.image ?? ''
          };

          const filtersPayload = (this.filters ?? [])
            .filter(f => f.tabId === t.id)
            .map(f => ({
              id: f.id ?? 0,
              code: f.code ?? 0,
              description: f.description ?? '',
              image: f.image ?? '',
              tabId: t.id
            }));

          const chartsPayload = (this.charts ?? [])
            .filter(c => c.tabId === t.id)
            .map(c => ({
              id: c.id ?? 0,
              code: c.code ?? 0,
              name: c.name ?? '',
              description: c.description ?? '',
              image: c.image ?? '',
              tabId: t.id
            }));

          const payloadForThisTab = {
            report: reportPayload,
            tab: tabPayload,
            filters: filtersPayload,
            charts: chartsPayload
          };

          console.log(payloadForThisTab)

          return this.sourceService.updateReport(payloadForThisTab);
        });

        if (requests.length) {
          forkJoin(requests).subscribe();
        } else {
          // Если вкладок нет — можно отправить одиночный запрос с пустыми вкладками (по необходимости)
          const singlePayload = { report: reportPayload, tabs: [], filters: [], charts: [] };
          this.sourceService.updateReport(singlePayload).subscribe();
        }
        break;
      }
    }
  }

  addRow(tableType: string) {
    switch (tableType) {
      case 'steps': {
        let step = {
          id: 0,
          procedureId: this.currentElement.id,
          step: 0,
          description: ''
        }
        this.currentElement.steps.push(step);
        break;
      }
    }
  }

  selectRow(index: number) {
    this.selectedStepIndex = index;
  }

  deleteRow(tableType: string) {
    switch (tableType) {
      case 'steps': {
        if (this.selectedStepIndex !== null && this.selectedStepIndex >= 0) {
          this.currentElement.steps.splice(this.selectedStepIndex, 1);
          this.selectedStepIndex = null;
        }
        break;
      }
    }
  }

  addSource() {
    if (!this.currentElement.sourceTables) {
      this.currentElement.sourceTables = [];
    }

    this.currentElement.sourceTables.push('новый источник');
    this.selectedSourceIndex = this.currentElement.sourceTables.length - 1;
  }

  removeSelectedSource() {
    if (this.selectedSourceIndex === null) return;
    this.currentElement.sourceTables.splice(this.selectedSourceIndex, 1);
    this.selectedSourceIndex = null;
  }

  selectSource(index: number) {
    this.selectedSourceIndex = this.selectedSourceIndex === index ? null : index;
  }


  async findElement() {
    const q = (this.searchText || '').trim();

    this.tables = [];
    this.functions = [];
    this.procedures = [];
    this.views = [];
    this.isSearching = false;

    if (!q) {
      this.tables = this.allTables;
      this.views = this.allViews;
      this.procedures = this.allProcedures;
      this.functions = this.allFunctions;

      for (let folder of this.filteredFolders) {
        folder.filteredReports = Array.isArray(folder.reports) ? folder.reports.slice() : [];
        folder.filteredReports = folder.filteredReports.filter(rep => rep.isCurrent === 1);
      }

      this.folderTree = this.buildFolderTree(this.filteredFolders || []);
      this.filteredSummarizedMetrics = Array.isArray(this.summarizedMetrics) ? this.summarizedMetrics.slice() : [];

      this.isSearching = false;
      return;
    }

    this.isSearching = true;
    const query = String(q).trim().toLowerCase();

    // нормализация
    const normalizeText = (s?: string) => (s ?? '').toString().normalize?.('NFKC').replace(/\s+/g, ' ').trim().toLowerCase();

    // DWH
    if (this.allTables?.length) {
      const wrappers = this.allTables.map((t: any) => {
        const colsText = (t.columns || [])
          .map((c: any) => [c?.name, c?.type, c?.description, c?.constraints].filter(Boolean).join(' '))
          .join(' ');
        const searchable = normalizeText(`${t.name ?? ''} ${t.description ?? ''} ${colsText}`);
        return { item: t, searchableText: searchable };
      });
      this.tables = wrappers.filter(w => w.searchableText.includes(query)).map(w => w.item);
    }

    if (this.allProcedures?.length) {
      const wrappers = this.allProcedures.map((p: ProcedureModel) => {
        const paramsText = (p.parameters || []).map(x => `${x.name} ${x.type} ${x.description}`).join(' ');
        const stepsText = (p.steps || []).map(s => s.description).join(' ');
        const searchable = normalizeText(`${p.name ?? ''} ${p.description ?? ''} ${p.definition ?? ''} ${p.author ?? ''} ${p.dataSource ?? ''} ${p.targetTable ?? ''} ${p.exampleUsage ?? ''} ${paramsText} ${stepsText}`);
        return { item: p, searchableText: searchable };
      });
      this.procedures = wrappers.filter(w => w.searchableText.includes(query)).map(w => w.item);
    }

    if (this.allFunctions?.length) {
      const wrappers = this.allFunctions.map((f: FunctionModel) => {
        const paramsText = (f.parameters || []).map(x => `${x.name} ${x.type} ${x.description}`).join(' ');
        const stepsText = (f.steps || []).map(s => s.description).join(' ');
        const searchable = normalizeText(`${f.name ?? ''} ${f.description ?? ''} ${f.definition ?? ''} ${f.author ?? ''} ${f.dataSource ?? ''} ${f.exampleUsage ?? ''} ${paramsText} ${stepsText}`);
        return { item: f, searchableText: searchable };
      });
      this.functions = wrappers.filter(w => w.searchableText.includes(query)).map(w => w.item);
    }

    if (this.allViews?.length) {
      const wrappers = this.allViews.map((v: ViewModel) => {
        const colsText = (v.columns || []).map((c: any) => [c?.name, (c as any)?.type, (c as any)?.description, (c as any)?.constraints].filter(Boolean).join(' ')).join(' ');
        const sourceTablesText = (v.sourceTables || []).join(' ');
        const searchable = normalizeText(`${v.name ?? ''} ${v.description ?? ''} ${v.definition ?? ''} ${v.author ?? ''} ${v.exampleUsage ?? ''} ${sourceTablesText} ${colsText}`);
        return { item: v, searchableText: searchable };
      });
      this.views = wrappers.filter(w => w.searchableText.includes(query)).map(w => w.item);
    }

    // BI: используем кэш (reportsCache, reportTabsCache, tabChartsCache, tabFiltersCache, summarizedMetricCache)
    if (this.isShowBI) {
      try {
        this.isLoadingAsync = true;

        const flatFolders = Array.isArray(this.filteredFolders) ? this.filteredFolders : [];

        type UnifiedWrapper = {
          type: 'folder' | 'report' | 'tab' | 'chart' | 'filter' | 'summarizedMetric' | 'metric';
          item: any;
          folderId?: number;
          reportId?: number;
          tabId?: number;
          summarizedMetricId?: number;
          metricId?: number;
          searchableText: string;
        };

        const unified: UnifiedWrapper[] = [];

        await Promise.all(flatFolders.map(f => this.getReportsCached(f.id)));

        for (const folder of flatFolders) {
          const reportsList: ReportResponse[] = this.reportsCache.get(folder.id)?.data ?? (Array.isArray(folder.reports) ? folder.reports.filter(x => x.isCurrent === 1) : []);
          const folderText = normalizeText(folder.name);
          const reportsText = (reportsList || [])
            .map((r: ReportResponse) => normalizeText(`${r.name ?? ''} ${r.description ?? ''} ${(r.sources || []).join(' ')} ${r.reference ?? ''}`))
            .filter(Boolean)
            .join(' ');
          unified.push({ type: 'folder', item: folder, folderId: folder.id, searchableText: normalizeText(`${folderText} ${reportsText}`) });

          for (const r of reportsList.filter(r => r.isCurrent === 1)) {
            unified.push({
              type: 'report',
              item: r,
              folderId: folder.id,
              reportId: r.id,
              searchableText: normalizeText(`${r.name ?? ''} ${r.description ?? ''} ${(r.sources || []).join(' ')} ${r.reference ?? ''}`)
            });
          }
        }

        if (Array.isArray(this.summarizedMetrics)) {
          await Promise.all(this.summarizedMetrics.map(sm => this.getMetricsCached(sm.id)));

          for (const sm of this.summarizedMetrics) {
            unified.push({
              type: 'summarizedMetric',
              item: sm,
              summarizedMetricId: sm.id,
              searchableText: normalizeText(`${sm.summarizedMetricName ?? ''}`)
            });

            const cachedMetrics = this.summarizedMetricCache.get(sm.id)?.data ?? [];
            for (const m of cachedMetrics) {
              const metricText = normalizeText(`${m.rawMetricAlias ?? ''} ${m.rawMetricName ?? ''}`);
              unified.push({
                type: 'metric',
                item: m,
                summarizedMetricId: sm.id,
                metricId: m.id,
                searchableText: metricText
              });
            }
          }
        }

        const reportIds = Array.from(new Set(unified.filter(u => u.type === 'report').map(u => u.reportId))).filter(Boolean) as number[];
        for (const rId of reportIds) {
          await this.getTabsCached(rId);
          const tabsArr = this.reportTabsCache.get(rId)?.data ?? [];
          await Promise.all(tabsArr.map(async tab => {
            await this.getChartsCached(tab.id);
            await this.getFiltersCached(tab.id);
          }));
        }

        for (const rId of reportIds) {
          const tabsArr = this.reportTabsCache.get(rId)?.data ?? [];
          for (const tab of tabsArr) {
            unified.push({ type: 'tab', item: tab, reportId: rId, tabId: tab.id, searchableText: normalizeText(`${tab.name ?? ''} ${tab.description ?? ''}`) });

            const chartsArr = this.tabChartsCache.get(tab.id)?.data ?? [];
            for (const ch of chartsArr) {
              unified.push({ type: 'chart', item: ch, reportId: rId, tabId: tab.id, searchableText: normalizeText(`${ch.name ?? ''} ${ch.description ?? ''} ${(ch.code ?? '')}`) });
            }

            const filtersArr = this.tabFiltersCache.get(tab.id)?.data ?? [];
            for (const f of filtersArr) {
              unified.push({ type: 'filter', item: f, reportId: rId, tabId: tab.id, searchableText: normalizeText(`${f.description ?? ''} ${(f.code ?? '')}`) });
            }
          }
        }

        const matched = unified.filter(u => u.searchableText.includes(query));

        const matchedFolderIds = new Set<number>();
        const matchedReportIds = new Set<number>();
        const matchedTabsByReport = new Map<number, Set<number>>();
        const matchedChartsByTab = new Map<number, Set<number>>();
        const matchedFiltersByTab = new Map<number, Set<number>>();
        const matchedSummarizedMetricIds = new Set<number>();
        const matchedMetricIds = new Set<number>();

        for (const w of matched) {
          if (!w) continue;
          switch (w.type) {
            case 'folder':
              if (w.folderId != null) matchedFolderIds.add(w.folderId);
              break;
            case 'report':
              if (w.reportId != null) matchedReportIds.add(w.reportId);
              break;
            case 'tab':
              if (w.reportId != null && w.tabId != null) {
                matchedReportIds.add(w.reportId);
                const s = matchedTabsByReport.get(w.reportId) ?? new Set<number>();
                s.add(w.tabId);
                matchedTabsByReport.set(w.reportId, s);
              }
              break;
            case 'chart':
              if (w.tabId != null && w.reportId != null && w.item?.id != null) {
                matchedReportIds.add(w.reportId);
                const sTab = matchedTabsByReport.get(w.reportId) ?? new Set<number>();
                sTab.add(w.tabId);
                matchedTabsByReport.set(w.reportId, sTab);
                const s = matchedChartsByTab.get(w.tabId) ?? new Set<number>();
                s.add(w.item.id);
                matchedChartsByTab.set(w.tabId, s);
              }
              break;
            case 'filter':
              if (w.tabId != null && w.reportId != null && w.item?.id != null) {
                matchedReportIds.add(w.reportId);
                const sTab = matchedTabsByReport.get(w.reportId) ?? new Set<number>();
                sTab.add(w.tabId);
                matchedTabsByReport.set(w.reportId, sTab);
                const s = matchedFiltersByTab.get(w.tabId) ?? new Set<number>();
                s.add(w.item.id);
                matchedFiltersByTab.set(w.tabId, s);
              }
              break;
            case 'summarizedMetric':
              if (w.summarizedMetricId != null) matchedSummarizedMetricIds.add(w.summarizedMetricId);
              break;
            case 'metric':
              if (w.metricId != null) matchedMetricIds.add(w.metricId);
              if (w.summarizedMetricId != null) matchedSummarizedMetricIds.add(w.summarizedMetricId);
              break;
          }
        }

        for (const u of unified.filter(x => x.type === 'metric' && matchedMetricIds.has(x.metricId ?? -1))) {
          if (u.summarizedMetricId != null) matchedSummarizedMetricIds.add(u.summarizedMetricId);
        }

        if (this.summarizedMetrics) {
          if (matchedSummarizedMetricIds.size > 0) {
            this.filteredSummarizedMetrics = this.summarizedMetrics.filter(sm => matchedSummarizedMetricIds.has(sm.id));
          } else {
            this.filteredSummarizedMetrics = [];
          }
        }

        const newFolders: any[] = [];
        for (const folder of flatFolders) {
          const folderReports: ReportResponse[] = this.reportsCache.get(folder.id)?.data ?? (Array.isArray(folder.reports) ? folder.reports : []);
          const filteredReportsForFolder: any[] = [];

          for (const rep of folderReports) {
            if (!matchedReportIds.has(rep.id)) continue;
            const repCopy: any = { ...rep };
            const tabsForReport = this.reportTabsCache.get(rep.id)?.data ?? [];
            const matchedTabsSet = matchedTabsByReport.get(rep.id) ?? new Set<number>();

            repCopy.matchedTabs = [];
            repCopy.matchedCharts = {};
            repCopy.matchedFilters = {};

            for (const tab of tabsForReport) {
              if (matchedTabsSet.size === 0 || matchedTabsSet.has(tab.id)) {
                repCopy.matchedTabs.push(tab);
                const charts = this.tabChartsCache.get(tab.id)?.data ?? [];
                const filters = this.tabFiltersCache.get(tab.id)?.data ?? [];
                const matchedChartIds = matchedChartsByTab.get(tab.id) ?? new Set<number>();
                const matchedFilterIds = matchedFiltersByTab.get(tab.id) ?? new Set<number>();
                repCopy.matchedCharts[tab.id] = matchedChartIds.size ? charts.filter(c => matchedChartIds.has(c.id)) : charts.slice();
                repCopy.matchedFilters[tab.id] = matchedFilterIds.size ? filters.filter(f => matchedFilterIds.has(f.id)) : filters.slice();
              }
            }

            filteredReportsForFolder.push(repCopy);
          }

          if (filteredReportsForFolder.length) {
            newFolders.push({ ...folder, filteredReports: filteredReportsForFolder });
          } else if (matchedFolderIds.has(folder.id)) {
            newFolders.push({ ...folder, filteredReports: (this.reportsCache.get(folder.id)?.data ?? (Array.isArray(folder.reports) ? folder.reports.slice() : [])) });
          }
        }

        this.folderTree = this.buildFolderTree(newFolders);
      } catch (err) {
        console.error('findElement error', err);
      } finally {
        this.isLoadingAsync = false;
      }
    }
  }


  exportToPDF() {
    if (!this.elementType || !this.currentElement) return;

    this.alertService.confirm({
      title: 'Внимание',
      message: `Экспортировать "${this.currentElement.name}" в PDF?`,
      confirmButtonText: 'Да',
      cancelButtonText: 'Отмена',
    }).subscribe(confirmed => {
      if (!confirmed) return;

      const handleBlobDownload = (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${this.currentElement.name}.pdf`;
        a.click();
        window.URL.revokeObjectURL(url);
      };

      const handleError = (err: any) => {
        console.error('Export error', err);
        this.alertService.error('Ошибка', 'Не удалось экспортировать файл');
      };

      switch (this.elementType) {
        case 'Table':
          this.sourceService.exportTables(this.currentElement.schemaId, this.currentElement.id)
            .subscribe(handleBlobDownload, handleError);
          break;
        case 'Procedure':
          this.sourceService.exportProcedures(this.currentElement.schemaId, this.currentElement.id)
            .subscribe(handleBlobDownload, handleError);
          break;
        case 'View':
          this.sourceService.exportViews(this.currentElement.schemaId, this.currentElement.id)
            .subscribe(handleBlobDownload, handleError);
          break;
        case 'Function':
          this.sourceService.exportFunctions(this.currentElement.schemaId, this.currentElement.id)
            .subscribe(handleBlobDownload, handleError);
          break;
        case 'Report':
          this.sourceService.exportReport(this.currentElement.folderId, this.currentElement.id)
            .subscribe(handleBlobDownload, handleError);
          break;
      }
    });
  }


  updateMeta() {
    if (!this.currentDataSource?.id) return;
    const request = { id: this.currentDataSource.id };

    this.pythonService.updateMetaDWH(request)
      .subscribe({
        next: (response) => {
          this.select(this.currentDataSource);
          this.alertService.success('', `Метаданные базы ${this.currentDataSource.dataSourceName} успешно обновлены`);
        },
        error: (err) => {
          console.error(err);
          this.alertService.error('Ошибка', 'Не удалось обновить метаданные');
        }
      });
  }


  async updateDesc() {
    let request = {
      datasource: {
        id: this.currentDataSource.id
      },
      object_type: this.elementType.toLowerCase(),
      object_id: this.currentElement.id
    }
    this.pythonService.updateDescriptionDWH(request).subscribe(async (response) => {

      switch (this.elementType) {
        case 'Table':
          await this.getTables(this.currentSchema.id)
          await this.displayElement(this.currentElement.id, this.elementType)
          break;
        case 'Procedure':
          await this.getProcedures(this.currentSchema.id)
          await this.displayElement(this.currentElement.id, this.elementType)
          break;
        case 'View':
          await this.getViews(this.currentSchema.id)
          await this.displayElement(this.currentElement.id, this.elementType)
          break;
        case 'Function':
          await this.getFunctions(this.currentSchema.id)
          await this.displayElement(this.currentElement.id, this.elementType)
          break;
      }
    })
  };

  async updateDataCatalogDesc() {
    let request = {
      datasource: {
        id: this.currentDataSource.id
      },
      object_type: this.elementType.toLowerCase(),
      object_id: this.currentElement.id
    }

    if (this.elementType === 'Report')
      this.pythonService.updateDataCatalogMetaReport(request).subscribe();
    else
      this.pythonService.updateDataCatalogMetaDWH(request).subscribe();
  };

  get createDtString(): string | null {
    if (!this.currentElement?.createDt) return null;
    const d = new Date(this.currentElement.createDt);

    return `${d.getFullYear()}-${('0' + (d.getMonth() + 1)).slice(-2)}-${('0' + d.getDate()).slice(-2)}`;
  }

  set createDtString(value: string | null) {
    if (value) this.currentElement.createDt = new Date(value);
  }


  openLineage() {
    this.sessionService.setItem('dataSource', this.currentDataSource)
    this.sessionService.setItem('currentElement', this.currentElement)
    this.sessionService.setItem('elementType', this.elementType)
    this.router.navigate(['/lineage']);
  }


}


